export default "__VITE_ASSET__FSL6x9kN__"